import { toast } from "react-toastify";
import { observable } from "mobx";
import { api } from "../../api";

export class _FgtsDigitalStore {
  obs = observable({
    tasks_fgts_digital: [] as any[],
    tasks_length: 0 as number,
    loading_solicitacao: false as boolean,
    loading_arquivos: false as boolean,
    loading_tasks: false as boolean,
    open_solicitar: false as boolean,
    page_agendamentos: 1 as number,
    index_agendamentos: [] as any,
    length_agendamentos: 0 as number,
    open_iframe: false as boolean,
    base64: "" as string,
    agendamentos_filter: false as boolean

  })

  async handleTasksPaged(paged: number, cnpj: string) {
    try {

      let data = {
        page: paged,
        limit: 15,
        cnpj: cnpj
      }

      let resp = await api.post("/api/fgtsdigital/index", data);

      console.log(resp)

      this.obs.tasks_fgts_digital = [];
      this.obs.tasks_length = 0

      if (resp.data.itens.length == 0) {

        toast.warning('Nenhuma solicitação foi encontrada, tente novamente mais tarde.', {});

      } else {

        this.obs.tasks_fgts_digital = resp.data.itens;

        this.obs.tasks_length = resp.data.count;

      }

    } catch (ex) { }

    this.obs.loading_tasks = false
  }

  async handleSolicitaFgtsDigital(params: any) {

    this.obs.loading_solicitacao = true

    try {

      let resp = await api.post("/api/fgtsdigital/create", params);

      if (resp.data) {

        toast.success('Solicitação realizada com sucesso!', {});

      } else {

        toast.error("Infelizmente, não foi possível realizar a solicitação para algumas empresas.", {});

      }

    } catch (ex) {

      toast.error("Erro ao realizar Solicitação, tente novamente mais tarde.", {});

    }

    FgtsDigitalStore.obs.loading_solicitacao = false

  }


  async downloadArquivos(fgts_digital_id: string, cnpj: string, tipo: string) {

    this.obs.loading_arquivos = true

    try {

      let params = {
        id: fgts_digital_id,
        tipo: tipo
      }

      let resp = await api.post(`/api/fgtsdigital/download`, params);

      if (resp.data.file) {

        const linkSource = `data:application/pdf;base64,${resp.data.file}`;
        const downloadLink = document.createElement("a");
        const fileName = `${cnpj}${tipo}.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {

        toast.error('Não foi encontrado um arquivo para download.', {});

      }

    } catch (ex) {

      toast.error('Erro Download Arquivo, tente novamente mais tarde.', {});

    }

    this.obs.loading_arquivos = false

  }

  async handleIndexAgendamentos(page: number) {

    let params = {
      page: page,
      limit: 5,
      recorrente: this.obs.agendamentos_filter
    }

    let resp = await api.post(`/api/fgtsdigital/agendamento/index`, params);

    this.obs.index_agendamentos = []
    this.obs.length_agendamentos = 0

    if (resp.data.itens.length > 0) {

      this.obs.index_agendamentos = resp.data.itens

      this.obs.length_agendamentos = resp.data.count

    }
  }

  async handleDeleteAgendamento(id: string) {
    try {

      let resp = await api.delete(`/api/fgtsdigital/agendamento/${id}`);

      if (resp.data.ok) {

        toast.success('Agendamento deletado com sucesso.', {});
        this.handleIndexAgendamentos(1)

      } else {

        toast.error('Erro ao deletar agendamento, tente novamente mais tarde.', {});

      }

    } catch (ex) {

      toast.error('Erro ao deletar agendamento, tente novamente mais tarde.', {});

    }

  }


}

export const FgtsDigitalStore = new _FgtsDigitalStore();
